import { CameraMover } from '../CameraMover';
import { AnimationPlayer } from './AnimationPlayer';
import { CameraMovementAnimationStep } from './CameraMovementAnimationStep';
import { PauseAnimationStep } from './PauseAnimationStep';
import type { CameraTargetProps, AnimationStepProps, AnimationProps } from '../../types';

type Props = {
  animation: AnimationProps;
  cameraMover: CameraMover;
  onComplete: () => void;
  setTimeoutManaged: (callback: () => void, delay: number) => void;
};

export const startAnimation = ({
  animation,
  cameraMover,
  onComplete,
  setTimeoutManaged,
}: Props): AnimationPlayer => {
  const steps = animation.steps.map((stepProps: AnimationStepProps) => {
    const { type, time } = stepProps;

    if (type === 'moveCamera') {
      const { cameraPosition, cameraLookAt } = stepProps;

      const cameraTarget: CameraTargetProps = {
        position: cameraPosition!,
        lookAt: cameraLookAt!,
      };
      const step = CameraMovementAnimationStep(cameraMover, { cameraTarget, transitionTime: time });
      return step;
    }

    if (type === 'pause') {
      return PauseAnimationStep({ transitionTime: time }, setTimeoutManaged);
    }

    throw new Error(`Invalid animation step type ${type} in animation ${animation.name}`);
  });

  const player = new AnimationPlayer(steps, onComplete);

  return player;
};
